// src/components/OrderTypeModal.tsx
import React, { useState } from 'react';
import { OrderTypeModalProps } from '../utils/types';
import { useNavigate } from 'react-router-dom';
import { useOrderType } from '../hooks/useOrderType';

const OrderTypeModal: React.FC<OrderTypeModalProps> = ({ isOpen, onClose }) => {
    const [selectedOrderType, setSelectedOrderType] = useState<string | null>(null);

    const { updateOrderType } = useOrderType();
    const navigate = useNavigate();

    const handleSelect = (orderType: string) => {
        updateOrderType(orderType);
        setSelectedOrderType(orderType);
        localStorage.setItem('orderType', orderType); // Store the selected order type in localStorage

        if (orderType === 'Dine In') {
            setSelectedOrderType('Dine In');
            onClose();
            navigate('/tables'); // Adjust this path as needed
        } else {
            setSelectedOrderType('Takeaway');
            onClose();
            navigate('/'); // Adjust this path as needed

        }
    };

    if (!isOpen) return null;

    return (
        <div className="z-30 fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-4 rounded shadow-3xl justify-items-center ">
                <h2 className="text-green-600 text-lg font-bold mb-4">{selectedOrderType}</h2>

                <h2 className="text-black text-lg font-bold mb-4">Select Order Type</h2>
                <div className="flex flex-col">
                    <button
                        className="px-4 py-2 mb-2 bg-blue-500 text-white rounded"
                        onClick={() => handleSelect('Dine In')}
                    >
                        Dine In
                    </button>
                    <button
                        className="px-4 py-2 bg-green-500 text-white rounded"
                        onClick={() => handleSelect('Takeaway')}
                    >
                        Takeaway
                    </button>
                </div>
                <button
                    className="mt-10 px-4 py-2 bg-red-500 text-white rounded"
                    onClick={onClose}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default OrderTypeModal;

